"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _headersContext = require("./headersContext");
Object.keys(_headersContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _headersContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _headersContext[key];
    }
  });
});
var _userSegmentationDataContext = require("./userSegmentationDataContext");
Object.keys(_userSegmentationDataContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userSegmentationDataContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _userSegmentationDataContext[key];
    }
  });
});
//# sourceMappingURL=index.js.map